import { render } from "./profileEditSkillsModal.vue?vue&type=template&id=a392c8aa&scoped=true"
import script from "./profileEditSkillsModal.vue?vue&type=script&lang=js"
export * from "./profileEditSkillsModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a392c8aa"

export default script